type EventName = 'landing' | 'tool_start' | 'operation_success' | 'operation_failure' | 'download' | 'tool_next';

const randomId = () => crypto.randomUUID();
const getStored = (key: string) => {
  let value = localStorage.getItem(key);
  if (!value) { value = randomId(); localStorage.setItem(key, value); }
  return value;
};

export function captureReferral() {
  const ref = new URLSearchParams(location.search).get('ref');
  if (ref && /^[a-zA-Z0-9_-]{1,64}$/.test(ref)) localStorage.setItem('plainimage_ref', ref.toLowerCase());
}

export function track(type: EventName, details: Record<string, unknown> = {}) {
  const campaign = new URLSearchParams(location.search);
  const payload = {
    eventId: randomId(), type,
    sessionId: getStored('plainimage_session'),
    visitorId: getStored('plainimage_visitor'),
    affiliateRef: localStorage.getItem('plainimage_ref') || undefined,
    path: location.pathname,
    referrerHost: document.referrer ? new URL(document.referrer).hostname : undefined,
    utmSource: campaign.get('utm_source') || undefined,
    utmMedium: campaign.get('utm_medium') || undefined,
    utmCampaign: campaign.get('utm_campaign') || undefined,
    ...details,
  };
  const data = JSON.stringify(payload);
  if (type === 'download' && navigator.sendBeacon) navigator.sendBeacon('/api/events', new Blob([data], { type: 'application/json' }));
  else void fetch('/api/events', { method: 'POST', headers: { 'content-type': 'application/json' }, body: data, keepalive: true }).catch(() => {});
}
